<div class="win-tumbler-wrapper">
    <div *ngIf="step === 1" class="step step1">
        <div>What To Win A Tumber?</div>
        <button (click)="step=2">Click To Enter</button>
    </div>
    <div *ngIf="step === 2" class="step step2">What Is Your Tic Tok Name?<input type="text"><button (click)="step=3">send</button></div>
    <div *ngIf="step === 3" class="step step3">Say Something<input type="text" > <button (click)="step=4">send</button></div>
    <div *ngIf="step === 4" class="step step4">Thanks!</div>
</div>

